import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  width = '100%',
  className = '',
  viewBox = '0 0 34 34',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      id="Caminho_2687"
      data-name="Caminho 2687"
      d="M7.567,149.681l-1.189,4.437-4.344.092a17.1,17.1,0,0,1-.126-15.942h0l3.867.709,1.694,3.844a10.189,10.189,0,0,0,.1,6.86Z"
      transform="translate(0 -129.12)"
      fill="#fbbb00"
    />
    <path
      id="Caminho_2688"
      data-name="Caminho 2688"
      d="M278.026,208.176a17.065,17.065,0,0,1-6.086,16.5h0l-4.871-.249-.689-4.3a10.175,10.175,0,0,0,4.378-5.2h-9.129v-6.754h16.4Z"
      transform="translate(-244.325 -194.437)"
      fill="#518ef8"
    />
    <path
      id="Caminho_2689"
      data-name="Caminho 2689"
      d="M56.233,319.16h0a17.078,17.078,0,0,1-25.725-5.223l5.532-4.529a10.153,10.153,0,0,0,14.631,5.2Z"
      transform="translate(-28.474 -288.919)"
      fill="#28b446"
    />
    <path
      id="Caminho_2690"
      data-name="Caminho 2690"
      d="M54.684,3.93,49.154,8.458a10.152,10.152,0,0,0-14.967,5.316L28.625,9.221h0a17.076,17.076,0,0,1,26.06-5.29Z"
      transform="translate(-26.715)"
      fill="#f14336"
    />
  </svg>
);

export default SVG;
